export const dateHelper = (lang: string) => new Intl.DateTimeFormat(lang, {
  month: "2-digit",
  day: "2-digit",
  year: "numeric",
});

export const setUtcZero = (date: Date) => {
  date.setHours(12, 0, 0, 0);
  return new Date(date.valueOf() - date.getTimezoneOffset() * 60000);
}